
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    totalDataRequest:0,
    dataRequestListing:[],
    dataRequestDetail:null
  };
  
  const dataRequestReducer = (state = initialState, action) => {
    // console.log("contact us reducers------", state,action);
   switch (action.type) {
     case "ADD_DATA_REQUEST_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_DATA_REQUEST_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_DATA_REQUEST_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_DATA_REQUEST_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_DATA_REQUEST_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_DATA_REQUEST_REQUEST_SUCCESS":
        return {
          ...state,
          dataRequestListing: action.payload,
          totalDataRequest:action.total,
          loading:false,
        };

      case "GOT_DATA_REQUEST_DETAIL":  
      return {
        ...state,
        dataRequestDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default dataRequestReducer;
  